import { WebPlugin } from '@capacitor/core';
export class GetAppInfoWeb extends WebPlugin {
    constructor() {
        super();
    }
    getAvailableApps() {
        throw new Error('Method not implemented.');
    }
    getAppIcon(options) {
        throw new Error(`Method not implemented. ${options}`);
    }
    getAppLabel(options) {
        throw new Error(`Method not implemented. ${options}`);
    }
    getFeature(options) {
        throw new Error(`Method not implemented. ${options}`);
    }
    isTV() {
        throw new Error(`Method not implemented.`);
    }
    launchApp(options) {
        throw new Error(`Method not implemented. ${options}`);
    }
    canLaunchApp(options) {
        throw new Error(`Method not implemented. ${options}`);
    }
}
//# sourceMappingURL=web.js.map